import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import type { SupportRealtimeEvent } from "@klantpunt/shared";
import { inboxKey, myTicketKey, myTicketsKey, notificationsKey, ticketKey } from "./api";

/**
 * Realtime (SSE, docs/HELPCENTER.md §8.3): de inbox luistert op het kanaal `support`, de klant op zijn
 * eigen berichten. Bij een event verversen de lijst en het geopende bericht, zonder herladen.
 */
export function useSupportEvents(kind: "support" | "customer", enabled = true) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled || typeof EventSource === "undefined") return;
    const es = new EventSource(kind === "support" ? "/api/support/events" : "/api/help/events");
    es.onmessage = (msg) => {
      try {
        const e = JSON.parse(msg.data) as SupportRealtimeEvent;
        if (kind === "support") {
          void qc.invalidateQueries({ queryKey: inboxKey });
          void qc.invalidateQueries({ queryKey: notificationsKey });
          void qc.invalidateQueries({ queryKey: ticketKey(e.ticketId) });
        } else {
          void qc.invalidateQueries({ queryKey: myTicketsKey });
          void qc.invalidateQueries({ queryKey: myTicketKey(e.ticketId) });
        }
      } catch {
        /* negeren */
      }
    };
    return () => es.close();
  }, [kind, enabled, qc]);
}
